<template>
  <div>
    <team-member-card
      photo-source="/assets/sid.png"
      name-and-credentials="Sandeep Kumar, Ph.D."
      position="Creater of MagicGraph"
    >
      Sandeep Kumar is an  applied mathematician and engineer, and is the creator of Edliy. He holds an M.S. from Caltech and earned his Ph.D. in applied math and computing from MIT. At MIT, Sandeep taught several undergraduate courses on applied math and mechanics. Students were introduced to some pretty advanced topics in these courses. But, oh, boy! Nothing was more notorious than a tensor. Tensor is a mathematical concept, and its abstractness makes it often hard and harrowing for students to grasp and appreciate.
      Every instructor who taught these courses knew of the frustration that the students faced with tensors.
      So, Sandeep decided to do something about it: He created an applet with a visually-interactive illustration of tensors
      based on Euclidean geometry. The applet proved to be an easy and effective way to learn tensors. And that was the beginning of Edliy.
    </team-member-card>
    <br>
    <team-member-card
      photo-source="/assets/sachith.png"
      name-and-credentials="Sachith Dunatunga, Ph.D."
      position="Head of Cybersecurity"
    >
      Sachith Dunatunga is a computer scientist and engineer, and is the head of Cybersecurity at Edliy.
      Sachith has an extensive experience in compiler designs and secure app technologies. Sachith received
      a B.S. in Mechanical Engineering from Caltech in 2011. He attended MIT as a doctoral student. For his doctoral dissertation, he
      developed and implemented granular material models using novel computational
      methods, culminating in a Ph.D. in 2017.
    </team-member-card>
    <br>
    <team-member-card
      photo-source="/assets/Nikith.jpeg"
      name-and-credentials="Nikith Rajendran, M.B.A."
      position="Chief Operating Officer"
    >
      Nikith Rajendran is an engineer and entrepreneur, and is the head of business strategy at Edliy.
      Prior to this, Nikith worked at Tesla and SolarCity for 6 years in various operations management roles where his work included enhancing employee productivity through the use of telematics.
      Given the extremely fast paced environment at these companies, rigorous planning and robust operations management techniques were necessary to help with the scaling up. His previous employers also include McKinsey and Amazon. He completed his Masters in Management Sciences &amp; Engineering at Stanford University and Masters in Manufacturing at MIT. His biggest passion is to accelerate the economic development of the under-privileged across the under-developed, developing and developed world and believes that access to quality education is one of the key enablers for such a mission. So he couldn't be more excited about the future of Edliy.
    </team-member-card>
    <br>
    <team-member-card
      photo-source="/assets/Katie.jpg"
      name-and-credentials="Katie Hartl, Ph.D."
      position="Chief Education Officer"
    >
      Katie has a PhD in experimental fluid mechanics from Princeton University and a Bachelors in mechanical engineering from Cornell University.
      When presented with the choice to study computational fluid mechanics or experimental fluid mechanics, she decided she would try her hand at laboratory work because it sounded way more fun.
      She performed the first Particle Image Velocimetry measurements in laboratory fire tornadoes.
      Her research has been published in 3 peer-reviewed journals (and counting).
      As a graduate student, she started an after school program that ran for three years called “Little Engineers” at the all-girls school she attended for grades K-12.
      Each week she created hands-on short lessons for ages K-3, mixing one part engineering with three parts art.
      She’s bringing her love of hands-on play to the platform where visual learning will shorten the time between learning a concept and getting your hands dirty.
    </team-member-card>
    <br>
    <team-member-card
      photo-source="/assets/Allison.jpg"
      name-and-credentials="Allison Pride, J.D."
      position="Curriculum Design"
    >
      Allison Pride is an established secondary mathematics educator at one of the most
      academically challenging high schools in the state of Texas. After earning her bachelor’s
      degree in business management at the University of Texas at Austin, she went on to earn
      her Juris Doctorate at Oklahoma City University’s School of Law.
      After passing the bar in Oklahoma and Texas, and practicing law for several years, she
      began teaching at a local college and paralegal school, thus finally realizing her true calling
      in education. Since her very first job was tutoring algebra and geometry students, she
      jumped at the chance to teach high school math. Throughout the years, she has taught
      algebra, geometry, and pre-calculus, and currently her favorite classes are financial math
      and discrete math.
      Now that she is teaching students online and face-to-face, her focus for the future is
      improving the interaction with her online students, integrating technology meaningfully
      into all lessons, and increasing the understanding and retention of the lessons.
    </team-member-card>
    <br>
    <team-member-card
      photo-source="/assets/simiand.jpg"
      name-and-credentials="Adriana Simiand, B.S."
      position="Content Development Lead"
    >
      Adriana is the content development lead at Edliy.
      She is a certified a civil engineer with expertise in structural health monitoring.
      Adriana is an avid programmer and using her coding skills to contribute to the technological advances that are happening at Edliy.
    </team-member-card>
    <br>
    <team-member-card
      photo-source="/assets/Yulin.jpg"
      name-and-credentials="Yulin Pan, Ph.D."
      position="Content Development Advisor"
    >
      Yulin Pan is an assistant professor of Naval Architecture and Marine Engineering at the University of Michigan, Ann Arbor.
      He has broad research interests in physics and mathematics, especially in those related to the fluid flow and the wave phenomenon.
      Before joining the University of Michigan in 2018, Yulin received his Ph.D. in mechanical and oceanographic engineering from M.I.T. in 2016, with his thesis devoted to the wave turbulence theory. His research has been published in many prestigious journals such as Physical Review Letters and Journal of Fluid Mechanics, and financially supported by the Office of Naval Research, NASA and industry partners. Alongside research, Yulin is also an active writer and educator on popular science of fluid mechanics.
    </team-member-card>
    <br>
    <team-member-card
      photo-source="/assets/Ken.jpg"
      name-and-credentials="Ken Kamrin, Ph.D."
      position="Board Member"
    >
      Ken Kamrin is an engineering scientist and mathematician, and is currently a faculty member of the Department of Mechanical Engineering at MIT.  From an early age Ken displayed a keen interest in physics and mathematics. His interest and passion for math and science took him to UC Berkeley, where he finished first-in-class in Engineering Physics.
      Upon graduation from UC Berkeley, Ken pursued a PhD in Applied Mathematics at MIT and received the APS Metropolis Award for outstanding thesis work in computational physics.  During his PhD, Ken developed a mathematical theory to describe the flow of granular materials.   After teaching and researching at Harvard for three years as an NSF Postdoctoral Fellow, in 2011, Ken joined the faculty of the department of Mechanical Engineering at MIT, and shortly thereafter received an appointment as the Class of 1956 Career Development Chair.
      He was awarded the NSF CAREER Award at the end of 2012 and won the 2015 Eshelby Mechanics Award for Young Faculty, cited for "fundamental contributions to mechanics of granular media".
    </team-member-card>
    <br>
    <team-member-card
      photo-source="/assets/Nenad.jpg"
      name-and-credentials="Nenad Miljkovic, Ph.D."
      position="Board Member"
    >
      Dr. Nenad Miljkovic is an Associate Professor of Mechanical Science and Engineering at the University of Illinois at Urbana-Champaign (UIUC), where he leads the Energy Transport Research Laboratory.
      He is the Associate Director of the Air Conditioning and Refrigeration Center (ACRC) &mdash; an NSF-founded I/UCRC at UIUC supported by 30 industrial partners. His research intersects the multidisciplinary fields of thermo-fluid science, interfacial phenomena, scalable nanomanufacturing, and renewable energy. In 2012, he was the recipient of the ASME Micro/Nano Heat Transfer Heat and Mass Transfer International Conference Best Paper Award, and in 2013 he received the Wunsch Foundation Silent Hoist and Crane Award for outstanding graduate research during his Ph.D. at MIT. He is a recipient of the NSF CAREER Award, the ACS PRF DNI Award, the ONR YIP Award, a Distinguished Visiting Fellowship from the UK Royal Academy of Engineering, a U.S. NAS Arab-American Frontiers Fellowship, the ASME ICNMM Young Faculty Award, the ASME Pi Tau Sigma Gold Medal, the CERL R&amp;D Technical Achievement Award, the UIUC Dean's Award for Excellence in Research, the U.S. Army Corps of Engineers ERDC R&amp;D Achievement Award. He is a Kritzer Faculty Scholar at the University of Illinois.
    </team-member-card>
    <br>
    <team-member-card
      photo-source="/assets/shruti.jpg"
      name-and-credentials="Shruti Bhatt, Ph.D."
      position="Board Member"
    >
      Shruti Bhatt is an Assistant Professor of Pharmaceutical Sciences at the National University of Singapore, an associate member of Cancer Science Institute Singapore, and a visiting scientist at Dana-Farber Cancer Institute, Boston. She received her Ph.D. in molecular and cellular pharmacology in 2014 from the University of Miami for identifying antibody-based novel therapeutic approaches for B-cell lymphoma.
      She trained as a translational leukemia scientist during her postdoctoral fellowship at Dana-Farber Cancer Institute and Harvard Medical School.
      Her postdoctoral research was focused on identifying predictive biomarkers that measure early response to chemotherapy/targeted therapy to personalized therapy for leukemia patients and mouse models.
      Her current research focuses on characterizing mechanisms and targeting approaches for relapsed leukemia using functional and genomic methods. For her contributions to cancer research, she has received numerous awards from several prestigious foundations, including the American association of cancer research, leukemia and lymphoma foundation, and the American society of hematology.
    </team-member-card>
    <br>
    <team-member-card
      photo-source="/assets/vikas-2.jpg"
      name-and-credentials="Vikas Srivastava, Ph.D."
      position="Board Member"
    >
      Vikas Srivastava received his Ph.D. in Mechanical Engineering from M.I.T. in 2010.
      Following his Ph.D., he worked at ExxonMobil Upstream and Corporate Strategic Research organizations in various research and leadership roles including Senior Technical Professional Advisor - Mechanics of Materials, Marine and Mechanics Team Lead, Fitness for Service Research Area Lead, and Deepwater Drilling Coordinator.
      He joined Brown University as an Assistant Professor of Engineering in the fall of 2018.
      Professor Srivastava's research focus at Brown University is in studying the role of fundamental solid mechanics in applications ranging from the biomedical sciences to engineering structures.
    </team-member-card>
    <br>
    <team-member-card
      photo-source="/assets/paco.png"
      name-and-credentials="Francisco Montero-Chacón, Ph.D."
      position="Board Member"
    >
      Francisco Montero-Chacón is an Associate Professor of the Civil and Mechanical Engineering and Deputy Director of the School of Engineering at the Universidad Loyola Andalucía. Francisco is a technology enthusiast interested in transforming research into real-world sustainable solutions, combining computers and mathematics to design better materials and structures for energy harvesting and storage.
      Francisco obtained his bachelor's degree in mechanical engineering from Universidad de Sevilla. He attended the California Institute of Technology to earn an M.S. in Aerospace Engineering.  He obtained a Ph.D. in Mechanical Engineering from Universidad de Sevilla. He also has a diploma in the Technology Management Program from Loyola Leadership School and The McDonough School of Business at Georgetown University. He has been a visiting researcher at the Cranfield University and the Delft University of Technology.
    </team-member-card>
  </div>
</template>
<script>
//import { mapGetters } from 'vuex';
//import Vue from 'vue';
import TeamMemberCard from './TeamMemberCard.vue';
export default {
  name: 'Team',
  components: {
    TeamMemberCard
  },
  metaInfo: {
        title: 'Edliy Team',
        meta: [
              {vmid:'description', name: 'description', content: 'Edliy\'s team includes educators, scientists and technologists trained at some of the world\'s most prestigious schools and institutions'},
              {vmid:'keywords', name: 'keywords', content: "Best teachers, learn through technology"},
              { vmid:'chars', charset: 'utf-8' },
              { vmid:'viewport', name: 'viewport', content: 'width=device-width, initial-scale=1' }],
        link: [{rel: 'canonical', href: 'https://edliy.com/team'}]
       },
       created ()  {
        //this.$store.dispatch('navigation/getData');
        this.$store.commit('navigation/resetState');
        let title = 'Our Team';
		    this.$store.commit('navigation/changeTitle', title);
		    //this.$store.commit('navigation/changeMenu', title);
		    let newshowhome = false;
		    this.$store.commit('navigation/toggleshowhome', newshowhome);
		    let newTeam =true;
		    this.$store.commit('navigation/replaceTeam', newTeam);
        this.$store.commit('navigation/replaceLeftArrow', true);
		  },
}
</script>
<style lang="scss">
body {
	background: #f1f1f1;
	font-family: 'Roboto', sans-serif;
}
.flex-item{
margin: 10px;
}
.IP-form {
	font-size: 20px;
	font-family: Lato;
	max-width: 800px;
	width: 100%;
	border-radius:5px;
	margin: 0 auto;
}
.IP-form .separator {
	border-bottom: solid 1px #ccc;
	margin-bottom: 15px;
}
.IP-form .form {
	display: flex;
	flex-direction: column;
	font-size: 16px;
	max-width: 425px;
	border-radius:5px;
	text-justify:center;
	margin: 0 auto;
	padding-bottom:25px;
}
.IP-form_title {
	color: #333;
	font-size: 32px;
	text-align:center;
	padding-top:20px;
}
.IP-form_subtitle {
	color: #333;
	font-size: 18px;
	text-justify:center;
	padding-left:35px;
	padding-right:15px;
}
</style>
